import React from "react";
import { Button } from "react-bootstrap";

const UiButton = ({ type, className, children, variant, size, style }) => {
  return (
    <Button
      type={type}
      variant={variant}
      size={size}
      style={style}
      className={`rounded-0 ${className}`}
    >
      {children}
    </Button>
  );
};

export default UiButton;
